// Label maps (key -> display text) whose text is translated at READ time: a property read calls i18n.t, so the
// module-level constants stay plain `MAP[key]` for every consumer and still follow the user's language.
// The English literal is the defaultValue (and the fallback if the key is missing).
import i18n from '../i18n';

export const i18nLabels = (prefix, en) => {
  const out = {};
  for (const [k, v] of Object.entries(en)) {
    Object.defineProperty(out, k, {
      enumerable: true,
      get: () => (i18n.isInitialized ? i18n.t(`${prefix}.${k.replace(/\W/g, '_')}`, { defaultValue: v }) : v),
    });
  }
  return out;
};

// A tuple (array) whose given indexes are translated at READ time: lazyTuple(['k', 'Label', '#c', 'Tip'], { 1: 'ns:key.label', 3: 'ns:key.tip' }).
// Destructuring / indexing / .map over the result all call the getters, so module-level quick-filter tables follow the language.
export const lazyTuple = (arr, keys, vars) => {
  const out = [...arr];
  for (const [i, key] of Object.entries(keys)) {
    const en = arr[i];
    Object.defineProperty(out, i, { enumerable: true, get: () => (i18n.isInitialized ? i18n.t(key, { defaultValue: en, ...vars }) : en) });
  }
  return out;
};
